/*
 * Data Route Registry
 *
 * Features:
 * - Combines modular /api/data route maps into the single lookup used by data.ts
 *
 * Changes:
 * - 2026-05-21: Registered Inbox CRUD routes
 */
import contactRoutes from "./contacts";
import noteRoutes from "./notes";
import accountRoutes from "./accounts";
import usersRoutes from "./users";
import teamsRoutes from "./teams";
import schemaRoutes from "./schema";
import newsRoutes from "./news";
import chatRoutes from "./chat";
import promptRoutes from "./prompts";
import kanbanRoutes from "./kanban";
import taskRoutes from "./tasks";
import inboxRoutes from "./inbox";

import { DataRoutes } from "./types";

const routes: DataRoutes = {
  ...contactRoutes,
  ...noteRoutes,
  ...accountRoutes,
  ...usersRoutes,
  ...teamsRoutes,
  ...schemaRoutes,
  ...newsRoutes,
  ...chatRoutes,
  ...promptRoutes,
  ...kanbanRoutes,
  ...taskRoutes,
  ...inboxRoutes
};

export default routes;
